module.exports = __webpack_public_path__ + "img/sec-288-kakaopay.f10932f8.svg";